const host = window.location.host

export const getEnv = (): 'local' | 'dev' | 'staging' | 'production' => {
  const devHosts = ['dev.sevalla.com']
  const stagingHosts = ['staging.sevalla.com']
  const prodHosts = ['app.sevalla.com', 'app-beta.sevalla.com']

  if (host.includes('localhost')) {
    return 'local'
  }
  if (
    devHosts.includes(host) ||
    host.includes('sevalla-dashboard-dev.pages.dev')
  ) {
    return 'dev'
  }
  if (stagingHosts.includes(host)) {
    return 'staging'
  }
  if (prodHosts.includes(host)) {
    return 'production'
  }

  return 'production'
}
